

<template>

<div class="card" id="">
    <h6 class="card-header">Inventory History</h6>
    <div class="card-body">
        <b-table staked="md" :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage" id="my-table">

            <template slot="details" slot-scope="row">
                <b-button size="sm" @click="showDetails(row.item)">
                    Details
                </b-button>
            </template>

            <template slot="date" slot-scope="row">
                {{getDate(row.item.createDate)}}
            </template>

            <template slot="user" slot-scope="row">
                {{row.item.adminUser.fname + " " + row.item.adminUser.lname}}
            </template>

            <template slot="ID" slot-scope="row">
                <div v-if="row.item.type == 'JOB'">
                    {{row.item.job.jobID}}
                </div>
                <div v-else>
                    {{row.item.key.oem}}
                </div>

            </template>

        </b-table>
        <b-row>
            <b-col md="3"></b-col>
            <b-col md="6" class="my-1">
                <v-pagination v-model="currentPage" :length="length" @input="pageChange" :total-visible="6"></v-pagination>
            </b-col>
            <b-col md="3"></b-col>
        </b-row>
    </div>


    <v-dialog v-if="item != null" v-model="details" transition="dialog-bottom-transition" fullscreen>

        <v-card fill-height>
            <v-toolbar dark dense color="primary">
                <v-btn icon dark @click="details = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Item History</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row>
                <v-col cols="2"></v-col>
                <v-col cols="8">
                    <v-card>
                        <v-card-title size="1.5rem">
                            User Details:
                        </v-card-title>
                        <v-row style="height:55px">
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field v-model="item.adminUser.username" dense outlined label="Username:"></v-text-field>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field v-model="item.adminUser.email" dense outlined label="Key OEM:"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row style="height:55px">
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field v-model="item.type" dense outlined label="Type:"></v-text-field>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-text-field :value="getDate(item.createDate)" dense outlined label="Date:"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <div v-if="item.type == 'RECEIVE_INVENTORY'">
                            <v-card-title size="1.2rem">
                                Inventory Received:
                                <div style="margin-left:10px">
                                    <v-chip outlined color="primary">{{item.item.key.oem}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.item.key.fcc}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.item.key.ic}}</v-chip>
                                </div>
                            </v-card-title>
                            <v-row>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field v-bind:key="loc.id" v-for="(loc) in item.info" style="height:55px" :value="loc.amount" readonly dense :label="loc.location.name" outlined></v-text-field>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-textarea outlined label="Notes" rows="2" :value="item.notes" readonly></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row style="height:120px">
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field style="height:50px" :value="item.cost" readonly dense label="Cost:" outlined></v-text-field>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field style="height:55px" :value="item.price" readonly dense label="Price:" outlined></v-text-field>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-if="item.type == 'ADJUST_INVENTORY'">
                            <v-card-title size="1.2rem">
                                Inventory Adjusted
                                <div style="margin-left:10px">
                                    <v-chip outlined color="primary">{{item.item.key.oem}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.item.key.fcc}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.item.key.ic}}</v-chip>
                                </div>
                            </v-card-title>
                            <v-row>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field v-bind:key="loc.id" v-for="(loc) in item.info" style="height:55px" :value="loc.amount" readonly dense :label="loc.location.name" outlined></v-text-field>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-textarea outlined rows="2" label="Notes" :value="item.notes" readonly></v-textarea>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-if="item.type == 'MOVE_INVENTORY'">
                            <v-card-title size="1.2rem">
                                Inventory Moved
                                <div style="margin-left:10px">
                                    <v-chip outlined color="primary">{{item.item.key.oem}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.item.key.fcc}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.item.key.ic}}</v-chip>
                                </div>
                            </v-card-title>
                            <v-row style="height:60px">
                                <v-col cols="1"></v-col>
                                <v-col cols="3">
                                          <v-text-field style="height:55px" :value="item.from.name" readonly dense label="From:" outlined></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                          <v-text-field style="height:55px" :value="item.to.name" readonly dense label="To:" outlined></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                          <v-text-field style="height:55px" :value="item.amount" readonly dense label="Amount" outlined></v-text-field>
                                </v-col>
                                <v-col cols="1"></v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="1"></v-col>
                                <v-col cols="5">
                                    <v-textarea outlined rows="2" label="Notes" :value="item.notes" readonly></v-textarea>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-if="item.type == 'JOB'">
                            <v-card-title size="1.2rem">
                                Inventory Adjusted
                                <div style="margin-left:10px">
                                    <v-chip outlined color="primary">{{item.key.oem}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.key.fcc}}</v-chip> -
                                    <v-chip outlined color="primary">{{item.key.ic}}</v-chip>
                                </div>
                            </v-card-title>
                            <v-row>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field style="height:55px" :value="item.job.jobTypes[0].jobType" readonly dense label="Job Type:" outlined></v-text-field>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field style="height:55px" :value="item.job.jobTypes[0].item.location.name" readonly dense label="Location:" outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field style="height:55px" :value="item.amount" readonly dense label="#Keys Used:" outlined></v-text-field>
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col cols="4">
                                    <v-text-field style="height:55px" :value="item.job.actual_price" readonly dense label="Price:" outlined></v-text-field>
                                </v-col>
                            </v-row>
                        </div>

                    </v-card>
                </v-col>
                <v-col cols="2"></v-col>
            </v-row>

        </v-card>



    </v-dialog>


</div>

</template>

<script>

export default {
    created() {
            this.$overlay.show(this);
            this.$api.getItemHistory(0).then((res => {
                if (res.status == 200) {
                    this.items.push(...res.data.content);
                }
                this.$overlay.hide();
            })).catch(er => {
                this.$overlay.hide();
            })
        },
        data: () => ({
            items: [],
            item: null,
            fields: [
                "user", "type", "ID", "date", "details"
            ],
            perPage: 5,
            details: false,
            currentPage: 1,
        }),
        computed: {
            length() {
                return Math.trunc(this.rows() / 6 + 1);
            }
        },
        methods: {
            rows() {
                    return this.items.length;
                },
                pageChange(page) {
                    let isLastPage = this.rows() / this.perPage;
                    if (page >= isLastPage)
                        this.$api.getItemHistory(page - 1).then((res => {
                            if (res.status == 200) {
                                if (!res.data.empty) {
                                    if (page == 1)
                                        this.items = res.data.content;
                                    else
                                        this.items.push(...res.data.content);
                                }
                            }
                        })).catch(er => {

                        })
                },
                showDetails(item) {
                    this.item = item;
                    this.details = true;
                },
                getDate(dat) {
                    let date = new Date(dat);
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? 'pm' : 'am';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    var strTime = hours + ':' + minutes + ' ' + ampm;
                    return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + "  " + strTime;
                }
        }
}

</script>
